import React from 'react'
import { Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useStoreState } from '../../store/store.hooks'
import { Heading } from '@/components/Text'
import { WhiteButton } from '@/components'
import { NavigateBack } from '@/components/Nav/NavigateBack'

const useStyles = makeStyles((theme) => ({
  burnoutBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
  },

  burnoutPaper: {
    padding: '1rem',
    background: '#F01E5A',
    color: 'white',
    borderRadius: theme.spacing(2),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  mentalAcademyChooseOne: {
    margin: '1rem 0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#1e2864',
  },

  mentalAcademyChooseOneButton: {
    width: '100%',
  },

  mentalAcademyChooseOneDescription: {
    fontSize: '0.9rem',
    margin: '1rem auto',
  },

  mentalAcademyChooseOneGrid: {
    display: 'flex',
    alignItems: 'stretch',
    padding: '1rem 4rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  },

  mentalAcademyChooseOneHeader: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    margin: '1rem auto',
  },

  mentalAcademyContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '15px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },

  mentalAcademyDigitalPlatform: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },

  mentalAcademyWelcome: {
    margin: '1rem 5rem',
    color: '#1e2864',
    fontSize: '1.2rem',
    fontWeight: 'bold',

    [theme.breakpoints.down('xs')]: {
      margin: '1rem 0rem',
    },
  },

  mentalAcademyWelcomeLine: {
    fontSize: '1rem',
  },

  stressBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
    height: '100%',
  },

  stressPaper: {
    padding: '1rem',
    background: '#45a1ea',
    color: 'white',
    borderRadius: theme.spacing(2),

    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  videoContainer: {
    position: 'relative',
    width: '100%',
    paddingBottom: '56.25%' /* 16:9 aspect ratio */,
    height: 0,
    overflow: 'hidden',
  },

  videoPlayer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },
}))

const MentalAcademy = (
  {
    /* props */
  }
) => {
  const classes = useStyles()
  const { t } = useTranslation('mentalAcademy')
  const { settingsByKey } = useStoreState((state) => state.settings)
  const videoUrl = settingsByKey['mental-academy-video-url']

  const navigateToBurnoutModule = () => {
    window.open(
      settingsByKey['mental-academy-burnout-module'],
      '_blank',
      'noopener,noreferrer'
    )
  }

  const navigateToStressModule = () => {
    window.open(
      settingsByKey['mental-academy-stress-module'],
      '_blank',
      'noopener,noreferrer'
    )
  }

  return (
    <>
      <Grid container xs={12} className={classes.mentalAcademyContainer}>
        <NavigateBack />
        <Heading>{t('mentalAcademyHeader')}</Heading>

        <Typography className={classes.mentalAcademyWelcome}>
          {t('mentalAcademyWelcome')}
        </Typography>

        <Typography className={classes.mentalAcademyWelcomeLine}>
          {t('mentalAcademyWelcomeLine1')}
        </Typography>
        <Typography className={classes.mentalAcademyWelcomeLine}>
          {t('mentalAcademyWelcomeLine2')}
        </Typography>
        <Typography className={classes.mentalAcademyWelcomeLine}>
          {t('mentalAcademyWelcomeLine3')}
        </Typography>

        {videoUrl && (
          <div className={classes.videoContainer}>
            <iframe
              src={videoUrl}
              width="640"
              height="360"
              allow="autoplay"
              className={classes.videoPlayer}
              title="Google Drive Video"
            />
          </div>
        )}

        <Typography className={classes.mentalAcademyChooseOne}>
          {t('mentalAcademyChooseOne')}
        </Typography>

        <Grid
          container
          xs={12}
          spacing={2}
          alignItems="space-between"
          className={classes.mentalAcademyChooseOneGrid}
        >
          <Grid item xs={12} md={6} className={classes.burnoutBox}>
            <Paper className={classes.burnoutPaper}>
              <Typography className={classes.mentalAcademyChooseOneHeader}>
                {t('mentalAcademyBurnoutHeader')}
              </Typography>
              <Typography className={classes.mentalAcademyChooseOneDescription}>
                {t('mentalAcademyBurnoutDescription')}
              </Typography>
              <br />
              <WhiteButton
                className={classes.mentalAcademyChooseOneButton}
                onClick={navigateToBurnoutModule}
              >
                {t('mentalAcademyBurnoutButtonText')}
              </WhiteButton>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6} className={classes.stressBox}>
            <Paper className={classes.stressPaper}>
              <Typography className={classes.mentalAcademyChooseOneHeader}>
                {t('mentalAcademyStressHeader')}
              </Typography>
              <Typography className={classes.mentalAcademyChooseOneDescription}>
                {t('mentalAcademyStressDescription')}
              </Typography>
              <WhiteButton
                className={classes.mentalAcademyChooseOneButton}
                onClick={navigateToStressModule}
              >
                {t('mentalAcademyStressButtonText')}
              </WhiteButton>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

MentalAcademy.displayName = 'MentalAcademy'
export { MentalAcademy }
export default MentalAcademy
